import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export default function BadgesEdit() {
  const [success, setSuccess] = useState("");
  const [error, setError] = useState([]);
  const [successStyle, setSuccessStyle] = useState({
    color: "black",
    display: "none",
  });
  const [errorStyle, setErrorStyle] = useState({
    color: "white",
    display: "none",
  });

  const [badgeId, setBadgeId] = useState("");
  const [badgeCategory, setBadgeCategory] = useState("");
  const [badgeName, setBadgeName] = useState("");
  const [badgeDescriptionDetailed, setBadgeDescriptionDetailed] = useState("");
  const [badgeDescriptionEarned, setBadgeDescriptionEarned] = useState("");
  const [badgePic, setBadgePic] = useState("");

  const [searchParams] = useSearchParams();
  const [image, setImage] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageStyle, setImageStyle] = useState({
    display: "none",
  });
  const [editImageStyle, setEditImageStyle] = useState({
    display: "block",
  });

  const Navigate = useNavigate();

  const params = {
    id: searchParams.get("id"),
  };
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("_token"),
    },
  };
  const getBadge = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "V1/badges/read",
        params,
        config
      );
      const badge = response.data.data;
      setBadgeId(badge.id);
      setBadgeCategory(badge.category);
      setBadgeName(badge.badge_name);
      setBadgeDescriptionDetailed(badge.badge_description_detailed);
      setBadgeDescriptionEarned(badge.badge_description_earned);
      setBadgePic(badge.image);
      setImageUrl(badge.image_url);
    } catch (err) {
      console.log(err);
    }
  };

  const handleOnChange = (e) => {
    setBadgePic(e.target.files[0]);
    setImage(URL.createObjectURL(e.target.files[0]));
    setImageStyle({
      display: "block",
    });
    setEditImageStyle({
      display: "none",
    });
  };

  const updateBadge = (e) => {
    e.preventDefault();

    if (!badgeCategory) {
      setError({ general: "Please select a category before submitting." });
      setErrorStyle({ color: "red", display: "block" });
      return;
    }

    if (!badgeName.trim()) {
      setError({ general: "Badge Name is required." });
      setErrorStyle({ color: "red", display: "block" });
      return;
    }

    let formData = new FormData();
    formData.append("id", badgeId);
    formData.append("category", badgeCategory);
    formData.append("badge_name", badgeName);
    formData.append("badge_description_detailed", badgeDescriptionDetailed);
    formData.append("badge_description_earned", badgeDescriptionEarned);
    if (badgePic instanceof File) {
      formData.append("image", badgePic);
    }

    axios
      .post(process.env.REACT_APP_API_URL + `V1/badges/update`, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("_token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
         
        setSuccess(response.data.message + ", redirecting to listing...");
        setErrorStyle({
          color: "red",
          display: "none",
        });
        setSuccessStyle({
          color: "black",
          display: "block",
        });

        setTimeout(() => {
          Navigate("/badges/all");
        }, 2000);
      })
      .catch((error) => {
        const msg = error?.response?.data?.message;
        setError(typeof msg === "object" && msg !== null ? msg : { general: msg || "Something went wrong. Please try again." });
        setErrorStyle({
          color: "red",
          display: "block",
        });
        setSuccessStyle({
          color: "black",
          display: "none",
        });
        console.log(error);
      });
  };

  useEffect(() => {
    getBadge();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeBadgeCategory = (e) => {
    setBadgeCategory(e.target.value);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Edit Badge</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    <Link to="/badges/all">Badges</Link>
                  </li>
                </ol>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-primary">
                  <div className="card-body" style={errorStyle}>
                    <h6>Errors</h6>
                    <ul>
                      {error.general && <li>{error.general}</li>}
                      {error.challenge_id && <li>Challenge: {error.challenge_id}</li>}
                      {error.category && <li>Category: {error.category}</li>}
                      {error.badge_name && <li>Badge Name: {error.badge_name}</li>}
                      {error.badge_description_detailed && <li>Description: {error.badge_description_detailed}</li>}
                      {error.badge_description_earned && <li>Description once Earned: {error.badge_description_earned}</li>}
                      {error.image && <li>Image: {error.image}</li>}
                    </ul>
                  </div>
                  <div className="card-body" style={successStyle}>
                    {success}
                  </div>
                  <form onSubmit={updateBadge}>
                    <input
                      type="hidden"
                      name="id"
                      value={searchParams.get("id")}
                    />
                    <div className="card-body">
                      <div className="form-group">
                        <label htmlFor="inputType">Category</label>
                        <select
                          className="form-control"
                          id="inputType"
                          onChange={handleChangeBadgeCategory}
                          value={badgeCategory}
                        >
                          <option value="">Select Category</option>
                          <option value="Special Challenges">Special Challenges</option>
                          <option value="Action Completion">Action Completion</option>
                          <option value="Ranking/Achievement">Ranking/Achievement</option>
                          <option value="Social">Social</option>
                          <option value="Fitness Challenge">Fitness Challenge</option>
                          <option value="Habit Challenge">Habit Challenge</option>
                          <option value="For a Cause">For a Cause</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="inputAward">Badge Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputAward"
                          placeholder="Enter Badge Name"
                          value={badgeName}
                          onChange={(e) => setBadgeName(e.target.value)}
                        />
                      </div>{" "}
                      <div className="form-group">
                        <label htmlFor="inputDescription">Description</label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputDescription"
                          placeholder="Enter Detailed Description"
                          value={badgeDescriptionDetailed}
                          onChange={(e) => setBadgeDescriptionDetailed(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="inputDescriptionEarned">Description once Earned</label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputDescriptionEarned"
                          placeholder="Enter Earned Description"
                          value={badgeDescriptionEarned}
                          onChange={(e) => setBadgeDescriptionEarned(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputImage">Image</label>
                        <input
                          type={"file"}
                          id={"exampleInputImage"}
                          onChange={handleOnChange}
                          className="form-control"
                        />
                        
                        {(() => {
                          if (imageUrl) {
                            return  <img alt="" src={imageUrl} width="10%" height="10%" style={editImageStyle}/>;
                          }
                        })()}
                        <img alt="" src={image} width="10%" height="10%" style={imageStyle} />
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
